import { Canvas } from "@react-three/fiber";
import { useRef } from "react";
import { OrthographicCamera } from "@react-three/drei";
import { DoubleSide } from "three";
import { Text } from "@react-three/drei";

const CircularText = ({ text, radius }) => {
    return (
        <>
            {text.split("").map((char, i) => {
                const angle = (i / text.length) * Math.PI * 2; // Evenly space letters
                const x = radius * Math.cos(angle);
                const y = radius * Math.sin(angle);

                return (
                    <Text
                        key={i}
                        position={[x, y, 0.02]} // Slightly above the ring
                        rotation={[0, 0, angle + Math.PI / 2]}
                        fontSize={0.4} // Larger text
                        color="white"
                        anchorX="center"
                        anchorY="middle"
                    >
                        {char}
                    </Text>
                );
            })}
        </>
    );
};

const Test = () => {
    const ringRef = useRef();

    return (
        <Canvas style={{ width: "150px", height: "150px" }}>
            {/* Set up an Orthographic Camera for proper scaling */}
            <OrthographicCamera makeDefault zoom={25} position={[0, 0, 5]} />
            {/* Ring */}
            <mesh ref={ringRef} rotation={[0, 0, 0]}>
                <ringGeometry args={[2, 2.5, 64]} /> {/* Bigger ring */}
                <meshBasicMaterial color="#2C3E50" side={DoubleSide} />
            </mesh>

            {/* Curved Text */}
            <CircularText text="CITY HALL • OLD PORT • " radius={2.25} />
        </Canvas>
    );
};

export default Test;
